<ng-template #loadingTemplate let-templateData="data">
  <div class="flex gap-2 w-full">
    <div class="flex-1">
      <p class="text-sm font-medium">
        <span [ngClass]="{ 'text-white break-all': true }">
          {{ templateData.content }}
        </span>
      </p>
    </div>

    <button nz-button nzType="text" nzShape="circle" nzSize="large" aria-label="close"
      class="!text-white hover:!text-success" (click)="closeNotification()">
      <svg-icon src="assets/svgs/cancel-icon.svg" [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"></svg-icon>
    </button>
  </div>
</ng-template>

<ng-template #errorTemplate let-templateData="data">
  <div class="flex gap-2 w-full">
    <div class="flex-1">
      <p class="text-sm font-medium">
        <span [ngClass]="{ 'text-white break-all': true }">
          {{ templateData.content }}
        </span>
      </p>
    </div>

    <button nz-button nzType="text" nzDanger nzShape="circle" nzSize="large" aria-label="close"
      (click)="closeNotification()" class="!text-white hover:!text-danger-400">
      <svg-icon src="assets/svgs/cancel-icon.svg" class="" [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"></svg-icon>
    </button>
  </div>
</ng-template>

<!-- <ng-template #loadingTemplate let-templateData="data">
  <div class="flex gap-3 text-white w-full">
    <div class="flex-1">
      <p class="text-sm font-medium">
        <span [ngClass]="{ 'text-white break-all': true }">
          {{ templateData.content }}
        </span>
      </p>
    </div>
    <button aria-label="close" class="" (click)="closeNotification()">
      <svg-icon src="assets/svgs/cancel-icon.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
    </button>
  </div>
</ng-template> -->